/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletVIcon16Regular = forwardRef('TechScreenTabletVIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 11a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 1A2.75 2.75 0 0 0 2 3.75v8.5A2.75 2.75 0 0 0 4.75 15h6.5A2.75 2.75 0 0 0 14 12.25v-8.5A2.75 2.75 0 0 0 11.25 1h-6.5ZM3.5 3.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-8.5Z" })));
});
